// @flow

import React, { Component, Fragment }     from 'react';
import PrintableReceipt                   from './PrintableReceipt';
import { connect } from 'react-redux';
import Header from '../Orders/Details/Header';


class ReceiptPage extends Component {



    render() {
        const { state } = this.props.location;
        if(state){
            const order = state;
            // TODO use the calculateAmountWithDicsount from ticket-utils
            if(order){
                if(order.promotionalTicket){
                    let feeAmountWithDiscount = (order.totalAmount - order.baseAmount);
                    let totalWithDiscount = order.totalAmount;
                    if (order.promotionalTicket.isPercent) {
                        let discount = feeAmountWithDiscount * (order.promotionalTicket.discount/100);
                        totalWithDiscount -= discount;
                    } else {
                        totalWithDiscount -= order.promotionalTicket.discount;
                    }
                    order.totalWithDiscount = totalWithDiscount

                };
            };
            return (
                    <Fragment>
                        <Header />
                        <div className="container-fluid mt--6">
                            <div className="row">
                                <div className="col">
                                    <div className="card shadow mb-5">
                                        <PrintableReceipt {...order}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
            )
        } else {
            return ('Não foi possível carregar as informações do termo');
        }
    };
};

export default ReceiptPage;


// WEBPACK FOOTER //
// ./src/components/Pages/Receipt/index.js